import { render, staticRenderFns } from "./CustomerAttach.vue?vue&type=template&id=4d2cba93&"
import script from "./CustomerAttach.vue?vue&type=script&lang=js&"
export * from "./CustomerAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports